<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <p><span style="font-size:14px;"><strong>{{$t("welcome_to_bt")}}</strong></span></p>
                        <p>
                            {{$t("logo_expl")}}
                        </p>
                        <p>
                            {{$t("who_is_bt")}}
                        </p>
                        <p>
                            {{$t("what_does_bt_deliver")}}
                        </p>

                        <ul>
                            <li>{{$t("elektrisch_handgereedschap")}}</li>
                            <li>{{$t("luchtgereedschappen")}}</li>
                            <li>{{$t("stationaire_machines")}}</li>
                            <li>{{$t("lastechniek")}}</li>
                            <li>{{$t("onderhoudsproducten")}}</li>
                            <li>{{$t("smeermiddelen")}}</li>
                            <li>{{$t("veiligheidsmiddelen")}}</li>
                            <li>{{$t("snij_en_verspanende_gereedschappen")}}</li>
                            <li>{{$t("persoonlijke_beschermingsmiddelen")}}</li>
                            <li>{{$t("aandrijftechniek")}}</li>
                            <li>{{$t("etc")}}</li>
                        </ul>

                        <p>{{$t("icw_unique_service")}}</p>

                        <p>
                            {{$t("together_with_team")}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import BtFooter from './BTFooter.vue'

    export default {
        name: 'Home',
        data() {
            return {
            }
        },
        created() {
            document.title = 'Technische Groothandel Brabant-Tools'
            this.$store.dispatch('getStarProduct').then(() => {
                if (this.products && this.products.length > 0) {
                    this.$modal.show('show-product-modal', { productId: this.products[0].id })
                }
            })
        },
        components: {
            BtFooter
        },
        computed: {
            ...mapGetters({
                products: 'products',
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
